module.exports = __webpack_public_path__ + "static/img/background.af6e6b26.svg";